/**
 * Store per la gestione dello stato delle email nel triage.
 * 
 * Utilizza Zustand per la gestione dello stato globale.
 */

import { create } from 'zustand';

export type FilterType = 
  | 'all' 
  | 'urgent' 
  | 'appointments' 
  | 'clinics' 
  | 'unassigned' 
  | 'conflicts';

export interface EmailState {
  // Stato
  selectedFilter: FilterType;
  selectedEmailId: string | null;
  selectedVetId: string | null;
  refreshInterval: number;
  
  // Actions
  setSelectedFilter: (filter: FilterType) => void;
  setSelectedEmail: (emailId: string | null) => void;
  setSelectedVet: (vetId: string | null) => void;
  setRefreshInterval: (interval: number) => void;
}

export const useEmailStore = create<EmailState>((set) => ({
  // Stato iniziale
  selectedFilter: 'all',
  selectedEmailId: null,
  selectedVetId: null,
  refreshInterval: 30000, // 30 secondi
  
  // Actions
  setSelectedFilter: (filter) => set({ selectedFilter: filter, selectedVetId: null }),
  setSelectedEmail: (emailId) => set({ selectedEmailId: emailId }),
  setSelectedVet: (vetId) => set({ selectedVetId: vetId, selectedFilter: 'all' }),
  setRefreshInterval: (interval) => set({ refreshInterval: interval }),
}));
